import { render, staticRenderFns } from "./OptionalMarketplace.vue?vue&type=template&id=156acd43"
import script from "./OptionalMarketplace.vue?vue&type=script&lang=ts"
export * from "./OptionalMarketplace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156acd43')) {
      api.createRecord('156acd43', component.options)
    } else {
      api.reload('156acd43', component.options)
    }
    module.hot.accept("./OptionalMarketplace.vue?vue&type=template&id=156acd43", function () {
      api.rerender('156acd43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/optionalSidebarItems/OptionalMarketplace.vue"
export default component.exports